/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { _get, _post, getShortName, server_url } from "../../Utils/Helper";
import { all_routes } from "../../router/all_routes";
import { toast } from "react-toastify";
import { Button, Collapse, Modal } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
const { Panel } = Collapse;

interface FormState {
  query_type: string;
  school_name: string;
  short_name: string;
  school_motto: string;
  state: string;
  lga: string;
  address: string;
  primary_contact_number: number | "";
  secondary_contact_number: number | "";
  email_address: string;
  school_id?: string;
  schoolMaster: boolean;
  expressFinance: boolean;
  resultStation: boolean;
  cbtPoint: boolean;
  nurserySection: boolean;
  primarySection: boolean;
  juniorSecondary: boolean;
  seniorSecondary: boolean;
  islamiyyah: boolean;
  tahfizu: boolean;
  admin_name: string;
  admin_email: string;
  admin_password: string;
  // admin_school_address: string;
  [key: string]: any;
}

interface BranchFormState {
  address: string;
  short_name: string;
}

interface SuccessModalProps {
  visible: boolean;
  onClose: () => void;
  schoolUrl: string;
}

const SchoolSetup = () => {
  const [loading, setLoading] = useState(false);
  const [schoolUrl, setSchoolUrl] = useState<string>("");
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState(false);
  const routes = all_routes;

  const generateSchoolId = () => {
    return Math.floor(100000 + Math.random() * 900000);
  };

  const _form: FormState = {
    query_type: "CREATE",
    school_name: "",
    short_name: "",
    school_motto: "",
    state: "",
    lga: "",
    address: "",
    school_id: '',
    primary_contact_number: "",
    secondary_contact_number: "",
    email_address: "",
    schoolMaster: false,
    expressFinance: false,
    resultStation: false,
    cbtPoint: false,
    nurserySection: false,
    primarySection: false,
    juniorSecondary: false,
    seniorSecondary: false,
    islamiyyah: false,
    tahfizu: false,
    badge_url: "",
    admin_name: "",
    admin_email: "",
    admin_password: ""
  };

  const [form, setForm] = useState<FormState>(_form);
  const [branches, setBranches] = useState<BranchFormState[]>([]);
  const [branchForm, setBranchForm] = useState<BranchFormState>({
    address: "",
    short_name: ""
  });
  const [isUploading, setIsUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState<string>("");
  // Handle file selection and upload
  const onChangeUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const attachmentFile = e.target.files ? e.target.files[0] : null;
    if (!attachmentFile) return;

    // Validate file size (5MB limit)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (attachmentFile.size > maxSize) {
      toast.error("File size exceeds the 5MB limit.");
      return;
    }
    const file = attachmentFile;
    if (file) {
      // Create a new FileReader to read the file
      const reader = new FileReader();

      // Set up onload event to update the preview when the file is read
      reader.onloadend = () => {
        setImagePreview(reader.result as string); // Set the result as the image URL
      };

      setIsUploading(true); // Set uploading state

      // Read the image file as a data URL
      reader.readAsDataURL(file);
    }
    // Prepare form data for upload
    setIsUploading(true);
    const formData = new FormData();
    formData.append("media", attachmentFile);

    // Upload the file
    fetch(server_url + "/upload_transfer_certificate-document", {
      method: "POST",
      body: formData
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setForm((prevForm: any) => ({ ...prevForm, badge_url: data.url }));
        toast.success("Uploaded successfully");
      })
      .catch((error) => {
        console.error("Error uploading attachment:", error);
        toast.error("Failed to upload the file.");
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, type, checked, value } = e.target;
    if(name==='school_name'){
      setForm((p)=>({...p, short_name:getShortName(value)}))
    }
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleBranchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setBranchForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const addBranch = () => {
    if (!branchForm.address || !branchForm.short_name) {
      toast.error("Please fill in all branch fields");
      return;
    }
    setBranches((prev) => [...prev, branchForm]);
    setBranchForm({ address: "", short_name: "" });
  };

  const handleSubmit = () => {
    // Validation
    // if (!form.school_name.trim()) {
    //   toast.error("Please enter school name");
    //   return;
    // }
    // if (!form.primary_contact_number.trim()) {
    //   toast.error("Please enter primary contact number");
    //   return;
    // }

    setLoading(true);

    const payload = {
      ...form
    };
    console.log(payload);

    _post(
      "school-setup",
      payload,
      (res) => {
        setLoading(false);
        if (res.success) {
          toast.success("School setup created successfully");
          setForm(_form);
          generateSchoolId();
          fetchSchoolUrl(res.school_id);
        }
      },
      (err) => {
        setLoading(false);
        toast.error(err.message || "Error creating school setup");
      }
    );
  };

  const fetchSchoolUrl = (schoolId: number) => {
    _get(
      `schools/${schoolId}/url`,
      (res) => {
        console.log(res);
        setSchoolUrl(res.url);
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const SuccessModal: React.FC<SuccessModalProps> = ({
    visible,
    onClose,
    schoolUrl
  }) => {
    return (
      <Modal
        title="School Created Successfully"
        visible={visible}
        onOk={onClose}
        onCancel={onClose}
        footer={[
          <Button key="close" onClick={onClose}>
            Close
          </Button>
        ]}
      >
        <p>Your school has been created successfully!</p>
        <p>
          School URL:{" "}
          <a href={schoolUrl} target="_blank" rel="noopener noreferrer">
            {schoolUrl}
          </a>
        </p>
      </Modal>
    );
  };
  return (
    <div className="page-wrapper">
      <div className="content content-two">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="mb-1">Add School</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={routes.studentList}>School Setup</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Add School
                </li>
              </ol>
            </nav>
          </div>
        </div>
        {/* /Page Header */}
        <div className="row">
          <div className="col-md-12">
            <form>
              {/* Personal Information */}
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-info-square-rounded fs-16" />
                    </span>
                    <h4 className="text-dark">School Information</h4>
                  </div>
                </div>

                <div className="card-body pb-1">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                        <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                          {imagePreview ? (
                            <img src={imagePreview} width={80} height={80} />
                          ) : (
                            <i className="ti ti-photo-plus fs-16" />
                          )}
                        </div>
                        <div className="profile-upload">
                          <div className="profile-uploader d-flex align-items-center">
                            <div className="drag-upload-btn mb-3">
                              Upload
                              <input
                                type="file"
                                onChange={onChangeUpload}
                                className="form-control image-sign"
                              />
                            </div>
                            <Button
                              onClick={() => {
                                setForm((p) => ({ ...p, badge_url: "" }));
                                setImagePreview("");
                              }}
                              className="btn btn-primary mb-3"
                            >
                              Remove
                            </Button>
                          </div>
                          <p className="fs-12">
                            {isUploading ? (
                              <p>Uploading...</p>
                            ) : (
                              "Upload image size 4MB, Format JPG, PNG, SVG"
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row row-cols-xxl-5 row-cols-md-6">
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">School Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="school_name"
                          value={form.school_name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          School Abbreviation
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="short_name"
                          value={form.short_name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">School Motto</label>
                        <input
                          type="text"
                          className="form-control"
                          name="school_motto"
                          value={form.school_motto}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">State</label>
                        <input
                          type="text"
                          className="form-control"
                          name="state"
                          value={form.state}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Local Government</label>
                        <input
                          type="text"
                          className="form-control"
                          name="lga"
                          value={form.lga}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input
                          type="text"
                          className="form-control"
                          name="address"
                          value={form.address}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Phone Number</label>
                        <input
                          type="number"
                          className="form-control"
                          name="primary_contact_number"
                          value={form.primary_contact_number}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Add Phone Number</label>
                        <input
                          type="number"
                          className="form-control"
                          name="secondary_contact_number"
                          value={form.secondary_contact_number}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Email Address</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email_address"
                          value={form.email_address}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    {/* <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">School Id</label>
                        <input
                          type="text"
                          className="form-control"
                          // disabled
                          name="school_id"
                          value={form.school_id}
                          onChange={handleChange}
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>

              {/* Admin card */}
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-user fs-16" />
                    </span>
                    <h4 className="text-dark">School Admin User</h4>
                  </div>
                </div>

                <div className="card-body pb-1">
                  <div className="row row-cols-xxl-4 row-cols-md-4">
                    {/* Admin Name */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Admin Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="admin_name"
                          value={form.admin_name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* Admin Email */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Admin Email</label>
                        <input
                          type="email"
                          className="form-control"
                          name="admin_email"
                          value={form.admin_email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* Admin Password */}
                    <div className="col-xxl col-xl-3 col-md-6">
                    <label className="form-label">Password</label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"} 
                          className="form-control"
                          name="admin_password"
                          value={form.admin_password}
                          onChange={handleChange}
                        />
                        <button
                          className="btn btn-outline-secondary"
                          type="button"
                          onClick={() => setShowPassword(!showPassword)} // Toggle visibility
                        >
                          {showPassword ? (
                            <EyeInvisibleOutlined />
                          ) : (
                            <EyeOutlined />
                          )}{" "}
                          {/* Toggle eye icon */}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <Collapse>
                <Panel header="Add Branch" key="1">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Branch Address</label>
                        <input
                          type="text"
                          className="form-control"
                          name="address"
                          value={branchForm.address}
                          onChange={handleBranchChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Branch Short Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="short_name"
                          value={branchForm.short_name}
                          onChange={handleBranchChange}
                        />
                      </div>
                    </div>
                  </div>
                  <Button type="primary" onClick={addBranch}>
                    Add Branch
                  </Button>
                </Panel>
              </Collapse> */}
              <br />
              {/* Subscription card  */}
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-info-square-rounded fs-16" />
                    </span>
                    <h4 className="text-dark">Features & Subscription Plan</h4>
                  </div>
                </div>

                <div className="card-body pb-1">
                  <div className="row row-cols-xxl-4 row-cols-md-4">
                    {/* School Master Checkbox */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="schoolMaster"
                          name="schoolMaster"
                          checked={form.schoolMaster}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="schoolMaster"
                        >
                          School Master
                        </label>
                      </div>
                    </div>

                    {/* Express Finance Checkbox */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="expressFinance"
                          name="expressFinance"
                          checked={form.expressFinance}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="expressFinance"
                        >
                          Express Finance
                        </label>
                      </div>
                    </div>

                    {/* Result Station Checkbox */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="resultStation"
                          name="resultStation"
                          checked={form.resultStation}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="resultStation"
                        >
                          Result Station
                        </label>
                      </div>
                    </div>

                    {/* CBT Point Checkbox */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="cbtPoint"
                          name="cbtPoint"
                          checked={form.cbtPoint}
                          onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="cbtPoint">
                          CBT Point
                        </label>
                      </div>
                    </div>
                    {/* Nursery Section Checkbox */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="nurserySection"
                          name="nurserySection"
                          checked={form.nurserySection}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="nurserySection"
                        >
                          Nursery Section
                        </label>
                      </div>
                    </div>

                    {/* Primary Section Checkbox */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="primarySection"
                          name="primarySection"
                          checked={form.primarySection}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="primarySection"
                        >
                          Primary Section
                        </label>
                      </div>
                    </div>

                    {/* Junior section Checkbox */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="juniorSecondary"
                          name="juniorSecondary"
                          checked={form.juniorSecondary}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="juniorSecondary"
                        >
                          Junior Secondary Section
                        </label>
                      </div>
                    </div>

                    {/* Senior Section Checkbox */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="seniorSecondary"
                          name="seniorSecondary"
                          checked={form.seniorSecondary}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="seniorSecondary"
                        >
                          Senior Secondary School
                        </label>
                      </div>
                    </div>
                    {/* islamiyya Checkbox */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="islamiyyah"
                          name="islamiyyah"
                          checked={form.islamiyyah}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="islamiyyah"
                        >
                          Islamiyya
                        </label>
                      </div>
                    </div>
                    {/* tahfiz Checkbox */}
                    <div className="col-xxl col-xl-3 col-md-6">
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="tahfizu"
                          name="tahfizu"
                          checked={form.tahfizu}
                          onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="tahfizu">
                          Tahfiz
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-end">
                <button type="button" className="btn btn-light me-3">
                  Cancel
                </button>
                <Button
                  type="primary"
                  loading={loading}
                  onClick={handleSubmit}
                  className="btn-primary"
                >
                  {loading ? "Submitting..." : "Submit"}
                </Button>
              </div>
            </form>

            <SuccessModal
              visible={isModalVisible}
              onClose={() => setIsModalVisible(false)}
              schoolUrl={schoolUrl}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchoolSetup;
